var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row gap-4 align-items-center"},[_c('DividerDotted',{staticClass:"mb-0 flex-grow-1"}),_vm._v(" "),_c('div',{staticClass:"font-size-sm text-uppercase text-muted user-select-none"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('DividerDotted',{staticClass:"mb-0 flex-grow-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }